import ClosableElement from './../closable-element';

class CountryPick {
	constructor() {
		this._init()
	}
	_init() {
		this.documentCountryISO = document.querySelector('meta[name=country]').content.split(',')[0].split('=')[1]
		document.querySelectorAll('[data-country-pick]').forEach(el => new CountryPickOption(el, this))
	}
}

class CountryPickOption {
	constructor(el, countryPicker) {
		this.el = el
		this.countryPicker = countryPicker
		this._init()
	}
	_init() {
		this.elAction = this.el.querySelector('[data-country-pick-action]')
		this.elContent = this.el.querySelector('[data-country-pick-content]')

		this.elAction.addEventListener('click', () => this.open(), false)
		// this.elContent.addEventListener('click', (ev) => this.change(ev, false))

		document.querySelectorAll('[data-country-pick-option]').forEach((el) => {
			el.addEventListener('click', () => {
				this.change(el)
			})
		})

		this.closableElement = new ClosableElement([this.el, this.elAction], () => this.close())
	}
	close() {
		if (!this.el)
			return
		// this.elContent.classList.remove('language__country-picker--is-open')
		this.elContent.style.display = 'none';
	}
	open() {
		if (!this.el)
			return
		// this.elContent.classList.add('language__country-picker--is-open')
		this.elContent.style.display = 'flex';
	}
	change(el) {
		const elCountryISO = el.dataset.countryPickOption

		if (elCountryISO == this.countryPicker.documentCountryISO)
			return

		const url = window.location.href
		const newUrl = url.split(`/${this.countryPicker.documentCountryISO}/`).join(`/${elCountryISO}/`)
		window.location.href = newUrl

		this.close()
	}
}

export default CountryPick